import { memo } from "react";

import { CenteredContainer } from "@hl/base-components/lib/CenteredContainer";
import { Mail as EmailMarketingIcon } from "@hl/base-components/lib/assets/icons.generated";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Space, Text, useMantineTheme } from "@mantine/core";

import ConditionBox from "~/features/gates/ConditionBox";

type SelectedMarketingAccessCardProps = {
  onRemoveCondition: () => void;
  email: boolean;
};

const SelectedMarketingAccessCard = ({
  onRemoveCondition,
}: SelectedMarketingAccessCardProps) => {
  const theme = useMantineTheme();
  return (
    <>
      <ConditionBox
        image={
          <CenteredContainer width={80} height={80} border>
            <EmailMarketingIcon
              width={32}
              height={32}
              color={theme.fn.themeColor(TEXT_COLOR.PRIMARY)}
            />
          </CenteredContainer>
        }
        description={<Text fw={500}>Has a verified email address</Text>}
        onRemoveCondition={onRemoveCondition}
      />
      <Space h="sm" />
    </>
  );
};

export default memo(SelectedMarketingAccessCard);
